import React, { ComponentProps, FC } from 'react';
import { FormattedMessage as LibFormattedMessage } from 'react-intl';

import { StringKey } from '../../lang/index';

type AppFormattedMessageProps = { id: StringKey } & ComponentProps<typeof LibFormattedMessage>;

export const AppFormattedMessage: FC<AppFormattedMessageProps> = ({ id, ...props }) => {
  return id !== 'EMPTY' ? <LibFormattedMessage id={id} {...props} /> : <div />;
};
